import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "s-card" }
const _hoisted_2 = {
  key: 0,
  class: "icon is-small"
}
const _hoisted_3 = {
  key: 0,
  class: "icon is-small"
}
const _hoisted_4 = {
  key: 0,
  class: "icon is-small"
}
const _hoisted_5 = { class: "checkbox is-outlined is-info" }
const _hoisted_6 = { class: "s-card mt-3" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "field-body" }
const _hoisted_9 = { class: "field has-addons" }
const _hoisted_10 = { class: "control is-expanded" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "control"
}
const _hoisted_13 = {
  key: 0,
  class: "field"
}
const _hoisted_14 = {
  key: 0,
  class: "select"
}
const _hoisted_15 = ["selected", "value"]
const _hoisted_16 = {
  key: 1,
  class: "select"
}
const _hoisted_17 = ["selected", "value"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = {
  key: 0,
  class: "help"
}
const _hoisted_20 = { key: `creator-error` }
const _hoisted_21 = { class: "table-container form-product-line" }
const _hoisted_22 = { class: "table is-hoverable is-fullwidth" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "s-card mt-3"
}
const _hoisted_25 = { class: "table-container" }
const _hoisted_26 = { class: "table is-hoverable is-fullwidth" }
const _hoisted_27 = ["title"]
const _hoisted_28 = {
  key: 1,
  class: "tag is-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VButton = _resolveComponent("VButton")!
  const _component_VControl = _resolveComponent("VControl")!
  const _component_VSwitchBlock = _resolveComponent("VSwitchBlock")!
  const _component_VField = _resolveComponent("VField")!
  const _component_ProductLineRow = _resolveComponent("ProductLineRow")!
  const _component_LegVolumesCalculatorModal = _resolveComponent("LegVolumesCalculatorModal")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_VField, { class: "columns is-multiline is-mobile" }, {
        default: _withCtx(() => [
          (_ctx.isStaff==true || _ctx.form.trader==_ctx.user.id || _ctx.route.name=='StrategiesCreate' || _ctx.route.name=='StrategiesCopy')
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 0,
                class: "column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VButton, {
                    onClick: _ctx.calcHouseWeights,
                    class: "is-fullwidth",
                    disabled: _ctx.form.productline_index.length>3
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("House weights", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isStaff==true || _ctx.form.trader==_ctx.user.id || _ctx.route.name=='StrategiesCreate' || _ctx.route.name=='StrategiesCopy')
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 1,
                class: "column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VButton, {
                    onClick: _ctx.calcWeights,
                    class: "is-fullwidth"
                  }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("Calc Exe", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isStaff==true || _ctx.form.trader==_ctx.user.id || _ctx.route.name=='StrategiesCreate' || _ctx.route.name=='StrategiesCopy')
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 2,
                class: "column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VButton, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLegVolumesModal = true)),
                    class: "is-fullwidth is-primary is-outlined"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("span", { class: "icon" }, [
                        _createElementVNode("i", { class: "fas fa-calculator" })
                      ], -1),
                      _createElementVNode("span", null, "Contract Volumes", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isStaff==true || _ctx.form.trader==_ctx.user.id || _ctx.route.name=='StrategiesCreate' || _ctx.route.name=='StrategiesCopy')
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 3,
                class: "column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VButton, {
                    onClick: _ctx.buildIndex,
                    disabled: _ctx.form.is_submitted,
                    class: "is-fullwidth"
                  }, {
                    default: _withCtx(() => [
                      _cache[20] || (_cache[20] = _createElementVNode("span", null, "Build", -1)),
                      (_ctx.form.is_submitted)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("i", { class: "fas fa-check has-text-success" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_VControl, { class: "column" }, {
            default: _withCtx(() => [
              _createVNode(_component_VButton, {
                class: _normalizeClass(["is-fullwidth", { 'is-warning is-outlined': !_ctx.form.is_submitted , 'is-info is-outlined': _ctx.form.is_submitted }]),
                onClick: _ctx.shareIndex
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("Share ", -1)
                ]))]),
                _: 1
              }, 8, ["class", "onClick"])
            ]),
            _: 1
          }),
          (!_ctx.isEditForm && _ctx.showStratToggleBtnPrc)
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 4,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showStratToggleBtnPrc = false)),
                class: "column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VButton, { class: "is-fullwidth" }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createTextVNode("Copy IN PRC RATIO ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEditForm && !_ctx.showStratToggleBtnPrc)
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 5,
                class: "column is-9"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.copyInTextPrc) = $event)),
                    class: "textarea",
                    rows: "8",
                    placeholder: "Copy strategy data.."
                  }, "        ", 512), [
                    [_vModelText, _ctx.copyInTextPrc]
                  ]),
                  _createVNode(_component_VButton, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyInProductLinesPrc())),
                    class: "is-fullwidth",
                    disabled: !_ctx.copyInTextPrc || /^\s*$/.test(_ctx.copyInTextPrc)
                  }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("span", null, "Copy IN", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEditForm && _ctx.showStratToggleBtnExec)
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 6,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showStratToggleBtnExec = false)),
                class: "column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VButton, { class: "is-fullwidth" }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode("Copy IN EXEC ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isEditForm && !_ctx.showStratToggleBtnExec)
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 7,
                class: "column is-9"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.copyInTextExec) = $event)),
                    class: "textarea",
                    rows: "8",
                    placeholder: "Copy strategy data.."
                  }, "        ", 512), [
                    [_vModelText, _ctx.copyInTextExec]
                  ]),
                  _createVNode(_component_VButton, {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copyInProductLinesExec())),
                    class: "is-fullwidth",
                    disabled: !_ctx.copyInTextExec || /^\s*$/.test(_ctx.copyInTextExec)
                  }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("span", null, "Copy IN", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEditForm)
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 8,
                class: "column"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_VButton, { class: "is-fullwidth" }, {
                    default: _withCtx(() => [
                      _cache[27] || (_cache[27] = _createElementVNode("span", null, "Copy OUT", -1)),
                      (_ctx.copiedOut)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("i", { class: "fas fa-check has-text-success" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })), [
                    [_directive_clipboard, _ctx.copyOutProductLines(), "copy"],
                    [_directive_clipboard, _ctx.copyOutSuccess, "success"]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isEditForm)
            ? (_openBlock(), _createBlock(_component_VControl, {
                key: 9,
                class: "column"
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_VButton, { class: "is-fullwidth" }, {
                    default: _withCtx(() => [
                      _cache[29] || (_cache[29] = _createElementVNode("span", null, "Copy CIX", -1)),
                      (_ctx.copiedCIX)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[28] || (_cache[28] = [
                            _createElementVNode("i", { class: "fas fa-check has-text-success" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })), [
                    [_directive_clipboard, _ctx.index.cix, "copy"],
                    [_directive_clipboard, _ctx.copyCIXSuccess, "success"]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isStaff==true || _ctx.form.trader==_ctx.user.id || _ctx.route.name=='StrategiesCreate' || _ctx.route.name=='StrategiesCopy')
            ? (_openBlock(), _createBlock(_component_VControl, { key: 10 }, {
                default: _withCtx(() => [
                  _createElementVNode("label", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.is_yield) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.is_yield]
                    ]),
                    _cache[30] || (_cache[30] = _createElementVNode("span", null, null, -1)),
                    _cache[31] || (_cache[31] = _createTextVNode(" is yield ", -1))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isStaff==true || _ctx.form.trader==_ctx.user.id || _ctx.route.name=='StrategiesCreate' || _ctx.route.name=='StrategiesCopy')
            ? (_openBlock(), _createBlock(_component_VControl, { key: 11 }, {
                default: _withCtx(() => [
                  _createVNode(_component_VSwitchBlock, {
                    color: "info",
                    modelValue: _ctx.form.is_forward,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.is_forward) = $event)),
                    label: "Spot/Forward"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[32] || (_cache[32] = _createElementVNode("label", { class: "label" }, "Name", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, [
              _createElementVNode("input", {
                class: "input",
                type: "text",
                name: "strat_name",
                onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.fieldUpdate && _ctx.fieldUpdate(...args))),
                value: _ctx.form.strat_name
              }, null, 40, _hoisted_11)
            ]),
            (!_ctx.form.strat_name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "button is-white is-outlined",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.generateName && _ctx.generateName(...args)))
                  }, " Generate name ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.isStaff)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _cache[35] || (_cache[35] = _createElementVNode("label", { class: "label" }, "User", -1)),
            (_ctx.route.name.includes('StrategiesCreate'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                  _createElementVNode("select", {
                    class: "select",
                    name: "creator",
                    onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.fieldUpdate && _ctx.fieldUpdate(...args)))
                  }, [
                    _cache[33] || (_cache[33] = _createElementVNode("option", { value: "0" }, "Please select...", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedUsers(_ctx.users), (user_list_item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: `product`,
                        selected: _ctx.user.id === user_list_item.id,
                        value: user_list_item.id
                      }, _toDisplayString(user_list_item.first_name) + " " + _toDisplayString(user_list_item.last_name), 9, _hoisted_15))
                    }), 128))
                  ], 32)
                ]))
              : _createCommentVNode("", true),
            (_ctx.route.name.includes('StrategiesUpdate'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                  _createElementVNode("select", {
                    class: "select",
                    name: "creator",
                    onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.fieldUpdate && _ctx.fieldUpdate(...args)))
                  }, [
                    _cache[34] || (_cache[34] = _createElementVNode("option", { value: "0" }, "Please select...", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedUsers(_ctx.users), (user_list_item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: `product`,
                        selected: _ctx.form.creator === user_list_item.id,
                        value: user_list_item.id
                      }, _toDisplayString(user_list_item.first_name) + " " + _toDisplayString(user_list_item.last_name), 9, _hoisted_17))
                    }), 128))
                  ], 32)
                ]))
              : _createCommentVNode("", true),
            (_ctx.apiErrors)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  ('creator' in _ctx.apiErrors)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiErrors['creator'], (error, index) => {
                            return (_openBlock(), _createElementBlock("li", _hoisted_20, _toDisplayString(error), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("table", _hoisted_22, [
          _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { scope: "col" }, "Key"),
              _createElementVNode("th", { scope: "col" }, "Product"),
              _createElementVNode("th", { scope: "col" }, "Prc ratio"),
              _createElementVNode("th", { scope: "col" }, "Exe ratio"),
              _createElementVNode("th", { scope: "col" }, "Del")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.productline_index, (values, index) => {
              return (_openBlock(), _createBlock(_component_ProductLineRow, {
                key: values.id,
                products: _ctx.products,
                rowId: index,
                values: values,
                isRemovable: _ctx.isRemovable,
                apiErrors: _ctx.productLineErrors[index],
                onRowUpdate: _ctx.rowUpdate,
                onRowRemove: _ctx.rowRemove
              }, null, 8, ["products", "rowId", "values", "isRemovable", "apiErrors", "onRowUpdate", "onRowRemove"]))
            }), 128))
          ])
        ]),
        (_ctx.isStaff==true || _ctx.form.trader==_ctx.user.id || _ctx.route.name=='StrategiesCreate' || _ctx.route.name=='StrategiesCopy')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.rowAdd && _ctx.rowAdd(...args)))
            }, [...(_cache[37] || (_cache[37] = [
              _createElementVNode("span", { class: "icon" }, [
                _createElementVNode("i", { class: "fas fa-plus" })
              ], -1),
              _createElementVNode("span", null, "Add another Product", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.isStaff==true || _ctx.form.trader==_ctx.user.id || _ctx.route.name=='StrategiesCreate' || _ctx.route.name=='StrategiesCopy')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "button is-outlined is-info ml-3",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.loadRiskData && _ctx.loadRiskData(...args))),
              disabled: _ctx.loadingRiskData
            }, [
              _cache[38] || (_cache[38] = _createElementVNode("span", { class: "icon" }, [
                _createElementVNode("i", { class: "fas fa-calculator" })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.loadingRiskData ? 'Loading...' : 'Get PV01 Risk Values'), 1)
            ], 8, _hoisted_23))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.riskData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _cache[40] || (_cache[40] = _createElementVNode("h3", { class: "subtitle" }, "PV01 Risk Values - All Current Products", -1)),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("table", _hoisted_26, [
              _cache[39] || (_cache[39] = _createElementVNode("thead", { class: "has-background-grey-darker" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Product"),
                  _createElementVNode("th", null, "Forward Risk"),
                  _createElementVNode("th", null, "Spot Risk"),
                  _createElementVNode("th", null, "Spot Yield"),
                  _createElementVNode("th", null, "Mid Price"),
                  _createElementVNode("th", null, "Status")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.riskData, (risk, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `risk-${index}`,
                    class: _normalizeClass({ 'has-background-danger': risk.error })
                  }, [
                    _createElementVNode("td", null, _toDisplayString(risk.product_name), 1),
                    _createElementVNode("td", null, _toDisplayString(risk.forward_risk !== null ? risk.forward_risk.toFixed(5) : '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(risk.spot_risk !== null ? risk.spot_risk.toFixed(5) : '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(risk.spot_yield !== null ? risk.spot_yield.toFixed(3) + '%' : '-'), 1),
                    _createElementVNode("td", null, _toDisplayString(risk.mid_price !== null && risk.mid_price !== undefined ? risk.mid_price.toFixed(6) : '-'), 1),
                    _createElementVNode("td", null, [
                      (risk.error)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "tag is-danger",
                            title: risk.error
                          }, "Error", 8, _hoisted_27))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, "✓"))
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_LegVolumesCalculatorModal, {
      open: _ctx.showLegVolumesModal,
      "product-lines": _ctx.form.productline_index,
      products: _ctx.products,
      "initial-volume": _ctx.initialKeyVolume || 100,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showLegVolumesModal = false)),
      onApply: _ctx.handleLegVolumesApply
    }, null, 8, ["open", "product-lines", "products", "initial-volume", "onApply"])
  ], 64))
}